<template>
<div class="chapter">
<div class="inner_page">
<p class="head">Acknowledgements</p>
<p class="noindent">Our thanks is offered to the many people who have assisted in the research and preparation of this book. We were warmly received by the Albert Gore Research Center at Middle Tennessee State University. Dr. James H. Williams has a wonderful staff for the center led by Mr. James Havron, archivist and coordinator, and ably assisted by Kelsey Fields, graduate assistant. The Gore Center holds a wealth of information about Murfreesboro during the Civil War years. The staff of the History Room at the Linebaugh Public Library in Murfreesboro were always available to assist in tracking down elusive bits and pieces of materials, especially microfilm of newspapers.</p>
<p class="indent">At Stones River National Battlefield Park, Mr. Gilbert Backlund, Mr. Jim Lewis and Mr. John R. George all gave freely of their time and knowledge to assist this effort. The staff at Oaklands has been quite gracious in providing photos of the interior and exterior of the house and in answering questions about the visit of Jefferson Davis to the Maney home. Special thanks to Nila Gober at Oaklands for her enthusiastic help.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?58248049